import { mainAPI, handleApiError } from "../api";

import { ApiErrorResponse } from "../types/api/error";
import {
  ScoringLeadsRequest,
  ScoringTableResponse,
  ScoringTableType,
  ScoringTabType,
} from "../types/api/scoring/scoring";

const path = `/monitoring/${process.env.REACT_APP_API_VERSION}/lead-scoring`;

// Таблицы скоринга - Получить список
export function fetchScoringTables() {
  return mainAPI.get<ScoringTableResponse[]>(`${path}/tables`).then(
    (res) => {
      const countHeader = res.headers["count"];
      return Promise.resolve({
        list: res.data,
        totalCount: countHeader,
      });
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(new Error(apiError?.detail || "Произошла ошибка"));
    }
  );
}

// Скоринг лидов - Получить
export function fetchScoringLeads<T = any>(
  tableName: ScoringTabType,
  tableType: ScoringTableType,
  params: ScoringLeadsRequest,
  signal?: AbortSignal
) {
  return mainAPI
    .post<T[]>(`${path}/tables/${tableName}/${tableType}`, params, { signal })
    .then(
      (res) => {
        const countHeader = res.headers["count"];
        return Promise.resolve({
          list: res.data,
          totalCount: countHeader,
        });
      },
      (error) => {
        if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
          return Promise.reject(new Error("Request canceled"));
        }
        const apiError: ApiErrorResponse = error.response?.data;
        return Promise.reject(
          new Error(apiError?.detail || "Произошла ошибка")
        );
      }
    );
}
// Скоринг лидов - Экспортировать
export function exportScoring(
  tableName: ScoringTabType,
  tableType: ScoringTableType,
  params: ScoringLeadsRequest
) {
  const filteredParams = params
    ? Object.fromEntries(
        Object.entries(params).filter(([_, value]) => value !== undefined)
      )
    : undefined;

  return mainAPI
    .post(
      `${path}/tables/${tableName}/${tableType}/excel`,
      filteredParams || {},
      {
        responseType: "blob",
      }
    )
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => {
        const apiError: ApiErrorResponse = error.response?.data;
        return Promise.reject(
          new Error(apiError?.detail || "Ошибка при экспорте скоринга")
        );
      }
    );
}
